export default __webpack_public_path__ + "static/media/cyro.86a77151.jpg";